"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63878,15596],{

/***/ 16165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41755);





var Icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(Component || children), 'Should have `component` prop or `children`.');
  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useInsertStyles */ .C3)();
  var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()('anticon', className);
  var svgClassString = classnames__WEBPACK_IMPORTED_MODULE_1___default()({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _utils__WEBPACK_IMPORTED_MODULE_3__/* .svgBaseProps */ .vD), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(viewBox) || react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon.displayName = 'AntdIcon';
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 31808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fk": function() { return /* binding */ detectFlexGapSupported; },
/* harmony export */   "jD": function() { return /* binding */ canUseDocElement; }
/* harmony export */ });
/* unused harmony export isStyleSupport */
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98924);

var canUseDocElement = function canUseDocElement() {
  return (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported() {
  if (!canUseDocElement()) {
    return false;
  }

  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  document.body.removeChild(flex);
  return flexGapSupported;
};

/***/ }),

/***/ 49288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50344);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var rc_util_es_omit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98423);
/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92961);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59844);
/* harmony import */ var _util_devWarning__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21687);
/* harmony import */ var _util_reactNode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96159);




/**
 * TODO: 4.0
 *
 * - Remove `dataSource`
 * - `size` not work with customizeInput
 * - CustomizeInput not feedback `ENTER` key since accessibility enhancement
 */








var Option = _select__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Option */ .Z.Option;

function isSelectOptionOrSelectOptGroup(child) {
  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}

var AutoComplete = function AutoComplete(props, ref) {
  var customizePrefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      dataSource = props.dataSource;
  var childNodes = (0,rc_util_es_Children_toArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(children); // ============================= Input =============================

  var customizeInput;

  if (childNodes.length === 1 && (0,_util_reactNode__WEBPACK_IMPORTED_MODULE_4__/* .isValidElement */ .l$)(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    var _childNodes = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(childNodes, 1);

    customizeInput = _childNodes[0];
  }

  var getInputElement = customizeInput ? function () {
    return customizeInput;
  } : undefined; // ============================ Options ============================

  var optionChildren; // [Legacy] convert `children` or `dataSource` into option children

  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(function (item) {
      if ((0,_util_reactNode__WEBPACK_IMPORTED_MODULE_4__/* .isValidElement */ .l$)(item)) {
        return item;
      }

      switch ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(item)) {
        case 'string':
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
            key: item,
            value: item
          }, item);

        case 'object':
          {
            var optionValue = item.value;
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
              key: optionValue,
              value: optionValue
            }, item.text);
          }

        default:
          throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
      }
    }) : [];
  } // ============================ Warning ============================


  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    (0,_util_devWarning__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!('dataSource' in props), 'AutoComplete', '`dataSource` is deprecated, please use `options` instead.');
    (0,_util_devWarning__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!customizeInput || !('size' in props), 'AutoComplete', 'You need to control style self instead of setting `size` when using customize input.');
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_8__/* .ConfigConsumer */ .C, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_select__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
      ref: ref
    }, (0,rc_util_es_omit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(props, ['dataSource']), {
      prefixCls: prefixCls,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("".concat(prefixCls, "-auto-complete"), className),
      mode: _select__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE */ .Z.SECRET_COMBOBOX_MODE_DO_NOT_USE,
      // Internal api
      getInputElement: getInputElement
    }), optionChildren);
  });
};

var RefAutoComplete = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
/* harmony default export */ __webpack_exports__["Z"] = (RefAutoComplete);

/***/ }),

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 99134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var RowContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (RowContext);

/***/ }),

/***/ 21584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71002);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99134);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59844);




var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






function parseFlex(flex) {
  if (typeof flex === 'number') {
    return "".concat(flex, " ").concat(flex, " auto");
  }

  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return "0 0 ".concat(flex);
  }

  return flex;
}

var sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var _classNames;

  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* .ConfigContext */ .E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useContext2 = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
      gutter = _React$useContext2.gutter,
      wrap = _React$useContext2.wrap,
      supportFlexGap = _React$useContext2.supportFlexGap;

  var customizePrefixCls = props.prefixCls,
      span = props.span,
      order = props.order,
      offset = props.offset,
      push = props.push,
      pull = props.pull,
      className = props.className,
      children = props.children,
      flex = props.flex,
      style = props.style,
      others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);

  var prefixCls = getPrefixCls('col', customizePrefixCls);
  var sizeClassObj = {};
  sizes.forEach(function (size) {
    var _extends2;

    var sizeProps = {};
    var propSize = props[size];

    if (typeof propSize === 'number') {
      sizeProps.span = propSize;
    } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(propSize) === 'object') {
      sizeProps = propSize || {};
    }

    delete others[size];
    sizeClassObj = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sizeClassObj), (_extends2 = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_extends2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _extends2));
  });
  var classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-order-").concat(order), order), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-push-").concat(push), push), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
  var mergedStyle = {}; // Horizontal gutter use padding

  if (gutter && gutter[0] > 0) {
    var horizontalGutter = gutter[0] / 2;
    mergedStyle.paddingLeft = horizontalGutter;
    mergedStyle.paddingRight = horizontalGutter;
  } // Vertical gutter use padding when gap not support


  if (gutter && gutter[1] > 0 && !supportFlexGap) {
    var verticalGutter = gutter[1] / 2;
    mergedStyle.paddingTop = verticalGutter;
    mergedStyle.paddingBottom = verticalGutter;
  }

  if (flex) {
    mergedStyle.flex = parseFlex(flex); // Hack for Firefox to avoid size issue
    // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553

    if (flex === 'auto' && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, others, {
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, mergedStyle), style),
    className: classes,
    ref: ref
  }), children);
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 3873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ row; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
// EXTERNAL MODULE: ./node_modules/antd/es/grid/RowContext.js
var RowContext = __webpack_require__(99134);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/type.js
var type = __webpack_require__(93355);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/responsiveObserve.js
var responsiveObserve = __webpack_require__(24308);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/styleChecker.js
var styleChecker = __webpack_require__(31808);
;// CONCATENATED MODULE: ./node_modules/antd/es/grid/hooks/useFlexGapSupport.js



/* harmony default export */ var useFlexGapSupport = (function () {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      flexible = _React$useState2[0],
      setFlexible = _React$useState2[1];

  react.useEffect(function () {
    setFlexible((0,styleChecker/* detectFlexGapSupported */.fk)());
  }, []);
  return flexible;
});
;// CONCATENATED MODULE: ./node_modules/antd/es/grid/row.js





var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








var RowAligns = (0,type/* tuple */.b)('top', 'middle', 'bottom', 'stretch');
var RowJustify = (0,type/* tuple */.b)('start', 'end', 'center', 'space-around', 'space-between');
var Row = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _classNames;

  var customizePrefixCls = props.prefixCls,
      justify = props.justify,
      align = props.align,
      className = props.className,
      style = props.style,
      children = props.children,
      _props$gutter = props.gutter,
      gutter = _props$gutter === void 0 ? 0 : _props$gutter,
      wrap = props.wrap,
      others = __rest(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = react.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  }),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      screens = _React$useState2[0],
      setScreens = _React$useState2[1];

  var supportFlexGap = useFlexGapSupport();
  var gutterRef = react.useRef(gutter); // ================================== Effect ==================================

  react.useEffect(function () {
    var token = responsiveObserve/* default.subscribe */.ZP.subscribe(function (screen) {
      var currentGutter = gutterRef.current || 0;

      if (!Array.isArray(currentGutter) && (0,esm_typeof/* default */.Z)(currentGutter) === 'object' || Array.isArray(currentGutter) && ((0,esm_typeof/* default */.Z)(currentGutter[0]) === 'object' || (0,esm_typeof/* default */.Z)(currentGutter[1]) === 'object')) {
        setScreens(screen);
      }
    });
    return function () {
      return responsiveObserve/* default.unsubscribe */.ZP.unsubscribe(token);
    };
  }, []); // ================================== Render ==================================

  var getGutter = function getGutter() {
    var results = [0, 0];
    var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach(function (g, index) {
      if ((0,esm_typeof/* default */.Z)(g) === 'object') {
        for (var i = 0; i < responsiveObserve/* responsiveArray.length */.c4.length; i++) {
          var breakpoint = responsiveObserve/* responsiveArray */.c4[i];

          if (screens[breakpoint] && g[breakpoint] !== undefined) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };

  var prefixCls = getPrefixCls('row', customizePrefixCls);
  var gutters = getGutter();
  var classes = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-no-wrap"), wrap === false), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-").concat(justify), justify), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-").concat(align), align), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className); // Add gutter related style

  var rowStyle = {};
  var horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : undefined;
  var verticalGutter = gutters[1] > 0 ? gutters[1] / -2 : undefined;

  if (horizontalGutter) {
    rowStyle.marginLeft = horizontalGutter;
    rowStyle.marginRight = horizontalGutter;
  }

  if (supportFlexGap) {
    // Set gap direct if flex gap support
    var _gutters = (0,slicedToArray/* default */.Z)(gutters, 2);

    rowStyle.rowGap = _gutters[1];
  } else if (verticalGutter) {
    rowStyle.marginTop = verticalGutter;
    rowStyle.marginBottom = verticalGutter;
  }

  var rowContext = react.useMemo(function () {
    return {
      gutter: gutters,
      wrap: wrap,
      supportFlexGap: supportFlexGap
    };
  }, [gutters, wrap, supportFlexGap]);
  return /*#__PURE__*/react.createElement(RowContext/* default.Provider */.Z.Provider, {
    value: rowContext
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, others, {
    className: classes,
    style: (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, rowStyle), style),
    ref: ref
  }), children));
});
Row.displayName = 'Row';
/* harmony default export */ var row = (Row);

/***/ }),

/***/ 69428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ input_number; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(15105);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/utils/supportUtil.js
function supportBigInt() {
  return typeof BigInt === 'function';
}
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/utils/numberUtil.js

/**
 * Format string number to readable number
 */

function trimNumber(numStr) {
  var str = numStr.trim();
  var negative = str.startsWith('-');

  if (negative) {
    str = str.slice(1);
  }

  str = str // Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
  .replace(/(\.\d*[^0])0*$/, '$1') // Remove useless decimal. `1.` => `1`
  .replace(/\.0*$/, '') // Remove integer 0. `0001` => `1`, 000.1' => `.1`
  .replace(/^0+/, '');

  if (str.startsWith('.')) {
    str = "0".concat(str);
  }

  var trimStr = str || '0';
  var splitNumber = trimStr.split('.');
  var integerStr = splitNumber[0] || '0';
  var decimalStr = splitNumber[1] || '0';

  if (integerStr === '0' && decimalStr === '0') {
    negative = false;
  }

  var negativeStr = negative ? '-' : '';
  return {
    negative: negative,
    negativeStr: negativeStr,
    trimStr: trimStr,
    integerStr: integerStr,
    decimalStr: decimalStr,
    fullStr: "".concat(negativeStr).concat(trimStr)
  };
}
function isE(number) {
  var str = String(number);
  return !Number.isNaN(Number(str)) && str.includes('e');
}
/**
 * [Legacy] Convert 1e-9 to 0.000000001.
 * This may lose some precision if user really want 1e-9.
 */

function getNumberPrecision(number) {
  var numStr = String(number);

  if (isE(number)) {
    var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
    var decimalMatch = numStr.match(/\.(\d+)/);

    if (decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) {
      precision += decimalMatch[1].length;
    }

    return precision;
  }

  return numStr.includes('.') && validateNumber(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
/**
 * Convert number (includes scientific notation) to -xxx.yyy format
 */

function num2str(number) {
  var numStr = String(number);

  if (isE(number)) {
    if (number > Number.MAX_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
    }

    if (number < Number.MIN_SAFE_INTEGER) {
      return String(supportBigInt() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
    }

    numStr = number.toFixed(getNumberPrecision(numStr));
  }

  return trimNumber(numStr).fullStr;
}
function validateNumber(num) {
  if (typeof num === 'number') {
    return !Number.isNaN(num);
  } // Empty


  if (!num) {
    return false;
  }

  return (// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num)
  );
}
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/utils/MiniDecimal.js



/* eslint-disable max-classes-per-file */


/**
 * We can remove this when IE not support anymore
 */

var NumberDecimal = /*#__PURE__*/function () {
  function NumberDecimal(value) {
    (0,classCallCheck/* default */.Z)(this, NumberDecimal);

    this.origin = '';

    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }

    this.origin = String(value);
    this.number = Number(value);
  }

  (0,createClass/* default */.Z)(NumberDecimal, [{
    key: "negate",
    value: function negate() {
      return new NumberDecimal(-this.toNumber());
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new NumberDecimal(value);
      }

      var target = Number(value);

      if (Number.isNaN(target)) {
        return this;
      }

      var number = this.number + target; // [Legacy] Back to safe integer

      if (number > Number.MAX_SAFE_INTEGER) {
        return new NumberDecimal(Number.MAX_SAFE_INTEGER);
      }

      if (number < Number.MIN_SAFE_INTEGER) {
        return new NumberDecimal(Number.MIN_SAFE_INTEGER);
      }

      var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(target));
      return new NumberDecimal(number.toFixed(maxPrecision));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function toString() {
      var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.isInvalidate()) {
        return safe ? '' : this.origin;
      }

      return num2str(this.number);
    }
  }]);

  return NumberDecimal;
}();
var BigIntDecimal = /*#__PURE__*/function () {
  function BigIntDecimal(value) {
    (0,classCallCheck/* default */.Z)(this, BigIntDecimal);

    this.origin = '';

    if (!value && value !== 0 || !String(value).trim()) {
      this.empty = true;
      return;
    }

    this.origin = String(value); // Act like Number convert

    if (value === '-') {
      this.nan = true;
      return;
    }

    var mergedValue = value; // We need convert back to Number since it require `toFixed` to handle this

    if (isE(mergedValue)) {
      mergedValue = Number(mergedValue);
    }

    mergedValue = typeof mergedValue === 'string' ? mergedValue : num2str(mergedValue);

    if (validateNumber(mergedValue)) {
      var trimRet = trimNumber(mergedValue);
      this.negative = trimRet.negative;
      var numbers = trimRet.trimStr.split('.');
      this.integer = BigInt(numbers[0]);
      var decimalStr = numbers[1] || '0';
      this.decimal = BigInt(decimalStr);
      this.decimalLen = decimalStr.length;
    } else {
      this.nan = true;
    }
  }

  (0,createClass/* default */.Z)(BigIntDecimal, [{
    key: "getMark",
    value: function getMark() {
      return this.negative ? '-' : '';
    }
  }, {
    key: "getIntegerStr",
    value: function getIntegerStr() {
      return this.integer.toString();
    }
  }, {
    key: "getDecimalStr",
    value: function getDecimalStr() {
      return this.decimal.toString().padStart(this.decimalLen, '0');
    }
    /**
     * Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */

  }, {
    key: "alignDecimal",
    value: function alignDecimal(decimalLength) {
      var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
      return BigInt(str);
    }
  }, {
    key: "negate",
    value: function negate() {
      var clone = new BigIntDecimal(this.toString());
      clone.negative = !clone.negative;
      return clone;
    }
  }, {
    key: "add",
    value: function add(value) {
      if (this.isInvalidate()) {
        return new BigIntDecimal(value);
      }

      var offset = new BigIntDecimal(value);

      if (offset.isInvalidate()) {
        return this;
      }

      var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
      var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
      var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
      var valueStr = (myAlignedDecimal + offsetAlignedDecimal).toString(); // We need fill string length back to `maxDecimalLength` to avoid parser failed

      var _trimNumber = trimNumber(valueStr),
          negativeStr = _trimNumber.negativeStr,
          trimStr = _trimNumber.trimStr;

      var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(maxDecimalLength + 1, '0'));
      return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -maxDecimalLength), ".").concat(hydrateValueStr.slice(-maxDecimalLength)));
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function isInvalidate() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function equals(target) {
      return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    }
  }, {
    key: "lessEquals",
    value: function lessEquals(target) {
      return this.add(target.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      if (this.isNaN()) {
        return NaN;
      }

      return Number(this.toString());
    }
  }, {
    key: "toString",
    value: function toString() {
      var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.isInvalidate()) {
        return safe ? '' : this.origin;
      }

      return trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
    }
  }]);

  return BigIntDecimal;
}();
function getMiniDecimal(value) {
  // We use BigInt here.
  // Will fallback to Number if not support.
  if (supportBigInt()) {
    return new BigIntDecimal(value);
  }

  return new NumberDecimal(value);
}
/**
 * Align the logic of toFixed to around like 1.5 => 2
 */

function toFixed(numStr, separatorStr, precision) {
  if (numStr === '') {
    return '';
  }

  var _trimNumber2 = trimNumber(numStr),
      negativeStr = _trimNumber2.negativeStr,
      integerStr = _trimNumber2.integerStr,
      decimalStr = _trimNumber2.decimalStr;

  var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
  var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);

  if (precision >= 0) {
    // We will get last + 1 number to check if need advanced number
    var advancedNum = Number(decimalStr[precision]);

    if (advancedNum >= 5) {
      var advancedDecimal = getMiniDecimal(numStr).add("0.".concat('0'.repeat(precision)).concat(10 - advancedNum));
      return toFixed(advancedDecimal.toString(), separatorStr, precision);
    }

    if (precision === 0) {
      return numberWithoutDecimal;
    }

    return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
  }

  if (precisionDecimalStr === '.0') {
    return numberWithoutDecimal;
  }

  return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/isMobile.js
var isMobile = __webpack_require__(31131);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/StepHandler.js





/**
 * When click and hold on a button - the speed of auto changing the value.
 */

var STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */

var STEP_DELAY = 600;
function StepHandler(_ref) {
  var prefixCls = _ref.prefixCls,
      upNode = _ref.upNode,
      downNode = _ref.downNode,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled,
      onStep = _ref.onStep;
  // ======================== Step ========================
  var stepTimeoutRef = react.useRef();
  var onStepRef = react.useRef();
  onStepRef.current = onStep; // We will interval update step when hold mouse down

  var onStepMouseDown = function onStepMouseDown(e, up) {
    e.preventDefault();
    onStepRef.current(up); // Loop step for interval

    function loopStep() {
      onStepRef.current(up);
      stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
    } // First time press will wait some time to trigger loop step update


    stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
  };

  var onStopStep = function onStopStep() {
    clearTimeout(stepTimeoutRef.current);
  };

  react.useEffect(function () {
    return onStopStep;
  }, []); // ======================= Render =======================

  if ((0,isMobile/* default */.Z)()) {
    return null;
  }

  var handlerClassName = "".concat(prefixCls, "-handler");
  var upClassName = classnames_default()(handlerClassName, "".concat(handlerClassName, "-up"), (0,defineProperty/* default */.Z)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
  var downClassName = classnames_default()(handlerClassName, "".concat(handlerClassName, "-down"), (0,defineProperty/* default */.Z)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
  var sharedHandlerProps = {
    unselectable: 'on',
    role: 'button',
    onMouseUp: onStopStep,
    onMouseLeave: onStopStep
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(handlerClassName, "-wrap")
  }, /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e) {
      onStepMouseDown(e, true);
    },
    "aria-label": "Increase Value",
    "aria-disabled": upDisabled,
    className: upClassName
  }), upNode || /*#__PURE__*/react.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-up-inner")
  })), /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, sharedHandlerProps, {
    onMouseDown: function onMouseDown(e) {
      onStepMouseDown(e, false);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": downDisabled,
    className: downClassName
  }), downNode || /*#__PURE__*/react.createElement("span", {
    unselectable: "on",
    className: "".concat(prefixCls, "-handler-down-inner")
  })));
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(80334);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/hooks/useCursor.js


/**
 * Keep input cursor in the correct position if possible.
 * Is this necessary since we have `formatter` which may mass the content?
 */

function useCursor(input, focused) {
  var selectionRef = (0,react.useRef)(null);

  function recordCursor() {
    // Record position
    try {
      var start = input.selectionStart,
          end = input.selectionEnd,
          value = input.value;
      var beforeTxt = value.substring(0, start);
      var afterTxt = value.substring(end);
      selectionRef.current = {
        start: start,
        end: end,
        value: value,
        beforeTxt: beforeTxt,
        afterTxt: afterTxt
      };
    } catch (e) {// Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  }
  /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */


  function restoreCursor() {
    if (input && selectionRef.current && focused) {
      try {
        var value = input.value;
        var _selectionRef$current = selectionRef.current,
            beforeTxt = _selectionRef$current.beforeTxt,
            afterTxt = _selectionRef$current.afterTxt,
            start = _selectionRef$current.start;
        var startPos = value.length;

        if (value.endsWith(afterTxt)) {
          startPos = value.length - selectionRef.current.afterTxt.length;
        } else if (value.startsWith(beforeTxt)) {
          startPos = beforeTxt.length;
        } else {
          var beforeLastChar = beforeTxt[start - 1];
          var newIndex = value.indexOf(beforeLastChar, start - 1);

          if (newIndex !== -1) {
            startPos = newIndex + 1;
          }
        }

        input.setSelectionRange(startPos, startPos);
      } catch (e) {
        (0,warning/* default */.ZP)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
      }
    }
  }

  return [recordCursor, restoreCursor];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(98924);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/hooks/useLayoutEffect.js


var useLayoutEffect = (0,canUseDom/* default */.Z)() ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/hooks/useUpdateEffect.js


/**
 * Work as `componentDidUpdate`
 */

function useUpdateEffect(callback, condition) {
  var initRef = react.useRef(false);
  useLayoutEffect(function () {
    if (!initRef.current) {
      initRef.current = true;
      return undefined;
    }

    return callback();
  }, condition);
}
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/InputNumber.js














/**
 * We support `stringMode` which need handle correct type when user call in onChange
 */

var getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
  if (stringMode || decimalValue.isEmpty()) {
    return decimalValue.toString();
  }

  return decimalValue.toNumber();
};

var getDecimalIfValidate = function getDecimalIfValidate(value) {
  var decimal = getMiniDecimal(value);
  return decimal.isInvalidate() ? null : decimal;
};

var InputNumber = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _classNames;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-input-number' : _props$prefixCls,
      className = props.className,
      style = props.style,
      min = props.min,
      max = props.max,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      defaultValue = props.defaultValue,
      value = props.value,
      disabled = props.disabled,
      readOnly = props.readOnly,
      upHandler = props.upHandler,
      downHandler = props.downHandler,
      keyboard = props.keyboard,
      stringMode = props.stringMode,
      parser = props.parser,
      formatter = props.formatter,
      precision = props.precision,
      decimalSeparator = props.decimalSeparator,
      onChange = props.onChange,
      onInput = props.onInput,
      onPressEnter = props.onPressEnter,
      onStep = props.onStep,
      inputProps = (0,objectWithoutProperties/* default */.Z)(props, ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep"]);

  var inputClassName = "".concat(prefixCls, "-input");
  var inputRef = react.useRef(null);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      focus = _React$useState2[0],
      setFocus = _React$useState2[1];

  var userTypingRef = react.useRef(false);
  var compositionRef = react.useRef(false); // ============================ Value =============================
  // Real value control

  var _React$useState3 = react.useState(function () {
    return getMiniDecimal(defaultValue !== null && defaultValue !== void 0 ? defaultValue : value);
  }),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      decimalValue = _React$useState4[0],
      setDecimalValue = _React$useState4[1];

  function setUncontrolledDecimalValue(newDecimal) {
    if (value === undefined) {
      setDecimalValue(newDecimal);
    }
  } // ====================== Parser & Formatter ======================

  /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing when auto generated.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */


  var getPrecision = react.useCallback(function (numStr, userTyping) {
    if (precision >= 0) {
      return precision;
    }

    if (userTyping) {
      return undefined;
    }

    return Math.max(getNumberPrecision(numStr), getNumberPrecision(step));
  }, [precision, step]); // >>> Parser

  var mergedParser = react.useCallback(function (num) {
    var numStr = String(num);

    if (parser) {
      return parser(numStr);
    }

    var parsedStr = numStr;

    if (decimalSeparator) {
      parsedStr = parsedStr.replace(decimalSeparator, '.');
    } // [Legacy] We still support auto convert `$ 123,456` to `123456`


    return parsedStr.replace(/[^\w.-]+/g, '');
  }, [parser, decimalSeparator]); // >>> Formatter

  var mergedFormatter = react.useCallback(function (number, userTyping) {
    if (formatter) {
      return formatter(number);
    }

    var str = typeof number === 'number' ? num2str(number) : number; // User typing will not auto format with precision directly

    if (!userTyping) {
      var mergedPrecision = getPrecision(str, userTyping);

      if (validateNumber(str) && (decimalSeparator || mergedPrecision >= 0)) {
        // Separator
        var separatorStr = decimalSeparator || '.';
        str = toFixed(str, separatorStr, mergedPrecision);
      }
    }

    return str;
  }, [formatter, getPrecision, decimalSeparator]); // ========================== InputValue ==========================

  /**
   * Input text value control
   *
   * User can not update input content directly. It update with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */

  var _React$useState5 = react.useState(function () {
    var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;

    if (decimalValue.isInvalidate() && ['string', 'number'].includes((0,esm_typeof/* default */.Z)(initValue))) {
      return Number.isNaN(initValue) ? '' : initValue;
    }

    return mergedFormatter(decimalValue.toString(), false);
  }),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      inputValue = _React$useState6[0],
      setInternalInputValue = _React$useState6[1]; // Should always be string


  function setInputValue(newValue, userTyping) {
    setInternalInputValue(mergedFormatter(newValue.toString(false), userTyping));
  } // >>> Max & Min limit


  var maxDecimal = react.useMemo(function () {
    return getDecimalIfValidate(max);
  }, [max]);
  var minDecimal = react.useMemo(function () {
    return getDecimalIfValidate(min);
  }, [min]);
  var upDisabled = react.useMemo(function () {
    if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }

    return maxDecimal.lessEquals(decimalValue);
  }, [maxDecimal, decimalValue]);
  var downDisabled = react.useMemo(function () {
    if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) {
      return false;
    }

    return decimalValue.lessEquals(minDecimal);
  }, [minDecimal, decimalValue]); // Cursor controller

  var _useCursor = useCursor(inputRef.current, focus),
      _useCursor2 = (0,slicedToArray/* default */.Z)(_useCursor, 2),
      recordCursor = _useCursor2[0],
      restoreCursor = _useCursor2[1]; // ============================= Data =============================

  /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */


  var getRangeValue = function getRangeValue(target) {
    // target > max
    if (maxDecimal && !target.lessEquals(maxDecimal)) {
      return maxDecimal;
    } // target < min


    if (minDecimal && !minDecimal.lessEquals(target)) {
      return minDecimal;
    }

    return null;
  };
  /**
   * Check value is in [min, max] range
   */


  var isInRange = function isInRange(target) {
    return !getRangeValue(target);
  };
  /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */


  var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
    var updateValue = newValue; // Skip align value when trigger value is empty.
    // We just trigger onChange(null)

    if (!updateValue.isEmpty()) {
      // Revert value in range if needed
      updateValue = getRangeValue(updateValue) || updateValue;
    }

    if (!readOnly && !disabled) {
      var numStr = updateValue.toString();
      var mergedPrecision = getPrecision(numStr, userTyping);

      if (mergedPrecision >= 0) {
        updateValue = getMiniDecimal(toFixed(numStr, '.', mergedPrecision));
      } // Trigger event


      if (!updateValue.equals(decimalValue)) {
        setUncontrolledDecimalValue(updateValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(updateValue.isEmpty() ? null : getDecimalValue(stringMode, updateValue)); // Reformat input if value is not controlled

        if (value === undefined) {
          setInputValue(updateValue, userTyping);
        }
      }

      return updateValue;
    }

    return decimalValue;
  }; // ========================== User Input ==========================
  // >>> Collect input value


  var collectInputValue = function collectInputValue(inputStr) {
    recordCursor(); // Update inputValue incase input can not parse as number

    setInternalInputValue(inputStr); // Parse number

    if (!compositionRef.current) {
      var finalValue = mergedParser(inputStr);
      var finalDecimal = getMiniDecimal(finalValue);

      if (!finalDecimal.isInvalidate()) {
        triggerValueUpdate(finalDecimal, true);
      }
    }
  }; // >>> Composition


  var onCompositionStart = function onCompositionStart() {
    compositionRef.current = true;
  };

  var onCompositionEnd = function onCompositionEnd() {
    compositionRef.current = false;
    collectInputValue(inputRef.current.value);
  }; // >>> Input


  var onInternalInput = function onInternalInput(e) {
    var inputStr = e.target.value; // optimize for chinese input experience
    // https://github.com/ant-design/ant-design/issues/8196

    if (!parser) {
      inputStr = inputStr.replace(/。/g, '.');
    }

    collectInputValue(inputStr); // Trigger onInput later to let user customize value if they want do handle something after onChange

    onInput === null || onInput === void 0 ? void 0 : onInput(inputStr);
  }; // ============================= Step =============================


  var onInternalStep = function onInternalStep(up) {
    var _inputRef$current;

    // Ignore step since out of range
    if (up && upDisabled || !up && downDisabled) {
      return;
    } // Clear typing status since it may caused by up & down key.
    // We should sync with input value.


    userTypingRef.current = false;
    var stepDecimal = getMiniDecimal(step);

    if (!up) {
      stepDecimal = stepDecimal.negate();
    }

    var target = (decimalValue || getMiniDecimal(0)).add(stepDecimal.toString());
    var updatedValue = triggerValueUpdate(target, false);
    onStep === null || onStep === void 0 ? void 0 : onStep(getDecimalValue(stringMode, updatedValue), {
      offset: step,
      type: up ? 'up' : 'down'
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }; // ============================ Flush =============================

  /**
   * Flush current input content to trigger value change & re-formatter input if needed
   */


  var flushInputValue = function flushInputValue() {
    var parsedValue = getMiniDecimal(mergedParser(inputValue));
    var formatValue = parsedValue;

    if (!parsedValue.isNaN()) {
      // Only validate value or empty value can be re-fill to inputValue
      // Reassign the formatValue within ranged of trigger control
      formatValue = triggerValueUpdate(parsedValue, true);
    } else {
      formatValue = decimalValue;
    }

    if (value !== undefined) {
      // Reset back with controlled value first
      setInputValue(decimalValue, false);
    } else if (!formatValue.isNaN()) {
      // Reset input back since no validate value
      setInputValue(formatValue, false);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    var which = event.which;
    userTypingRef.current = true;

    if (which === KeyCode/* default.ENTER */.Z.ENTER) {
      if (!compositionRef.current) {
        userTypingRef.current = false;
      }

      flushInputValue();
      onPressEnter === null || onPressEnter === void 0 ? void 0 : onPressEnter(event);
    }

    if (keyboard === false) {
      return;
    } // Do step


    if (!compositionRef.current && [KeyCode/* default.UP */.Z.UP, KeyCode/* default.DOWN */.Z.DOWN].includes(which)) {
      onInternalStep(KeyCode/* default.UP */.Z.UP === which);
      event.preventDefault();
    }
  };

  var onKeyUp = function onKeyUp() {
    userTypingRef.current = false;
  }; // >>> Focus & Blur


  var onBlur = function onBlur() {
    flushInputValue();
    setFocus(false);
  }; // ========================== Controlled ==========================
  // Input by precision


  useUpdateEffect(function () {
    if (!decimalValue.isInvalidate()) {
      setInputValue(decimalValue, false);
    }
  }, [precision]); // Input by value

  useUpdateEffect(function () {
    var newValue = getMiniDecimal(value);
    setDecimalValue(newValue); // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
    // But let it go if user set `formatter`

    if (newValue.isNaN() || !userTypingRef.current || formatter) {
      // Update value as effect
      setInputValue(newValue, false);
    }
  }, [value]); // ============================ Cursor ============================

  useUpdateEffect(function () {
    if (formatter) {
      restoreCursor();
    }
  }, [inputValue]); // ============================ Render ============================

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(prefixCls, className, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-focused"), focus), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-readonly"), readOnly), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue)), _classNames)),
    style: style,
    onFocus: function onFocus() {
      setFocus(true);
    },
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd
  }, /*#__PURE__*/react.createElement(StepHandler, {
    prefixCls: prefixCls,
    upNode: upHandler,
    downNode: downHandler,
    upDisabled: upDisabled,
    downDisabled: downDisabled,
    onStep: onInternalStep
  }), /*#__PURE__*/react.createElement("div", {
    className: "".concat(inputClassName, "-wrap")
  }, /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
    step: step
  }, inputProps, {
    ref: (0,es_ref/* composeRef */.sQ)(inputRef, ref),
    className: inputClassName,
    value: inputValue,
    onChange: onInternalInput,
    disabled: disabled,
    readOnly: readOnly
  }))));
});
InputNumber.displayName = 'InputNumber';
/* harmony default export */ var es_InputNumber = (InputNumber);
;// CONCATENATED MODULE: ./node_modules/rc-input-number/es/index.js

/* harmony default export */ var es = (es_InputNumber);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UpOutlined.js
// This icon file is generated automatically.
var UpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
/* harmony default export */ var asn_UpOutlined = (UpOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpOutlined_UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, Object.assign({}, props, {
    ref: ref,
    icon: asn_UpOutlined
  }));
};

UpOutlined_UpOutlined.displayName = 'UpOutlined';
/* harmony default export */ var icons_UpOutlined = (/*#__PURE__*/react.forwardRef(UpOutlined_UpOutlined));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(80882);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
;// CONCATENATED MODULE: ./node_modules/antd/es/input-number/index.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};








var input_number_InputNumber = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _classNames;

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = react.useContext(SizeContext/* default */.Z);

  var className = props.className,
      customizeSize = props.size,
      customizePrefixCls = props.prefixCls,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      readOnly = props.readOnly,
      others = __rest(props, ["className", "size", "prefixCls", "bordered", "readOnly"]);

  var prefixCls = getPrefixCls('input-number', customizePrefixCls);
  var upIcon = /*#__PURE__*/react.createElement(icons_UpOutlined, {
    className: "".concat(prefixCls, "-handler-up-inner")
  });
  var downIcon = /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, {
    className: "".concat(prefixCls, "-handler-down-inner")
  });
  var mergeSize = customizeSize || size;
  var inputNumberClass = classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-lg"), mergeSize === 'large'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-sm"), mergeSize === 'small'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-readonly"), readOnly), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames), className);
  return /*#__PURE__*/react.createElement(es, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: inputNumberClass,
    upHandler: upIcon,
    downHandler: downIcon,
    prefixCls: prefixCls,
    readOnly: readOnly
  }, others));
});
/* harmony default export */ var input_number = (input_number_InputNumber);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3873);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 70420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  border: 1px solid ',
        " !important;\n  border-color: ",
        " !important;\n  box-shadow: none !important;\n\n  :hover,\n  :focus {\n    border: 1px solid ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c892a315-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 48469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  width: ',
        ";\n\n  ",
        "\n\n  .ant-select-selector {\n    border: ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width,
        border: props.border || "1px solid"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-e69d6f89-0"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var border = param.border;
    return border;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp10 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 27934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LivePriceSymbolsKeyEnum; }
/* harmony export */ });
var LivePriceSymbolsKeyEnum;
(function(LivePriceSymbolsKeyEnum) {
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_WATCHLIST"] = "sideWidgetWatchlist";
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    LivePriceSymbolsKeyEnum["COMPANY_HERO"] = "companyHero";
    LivePriceSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    LivePriceSymbolsKeyEnum["TRENDING_STOCK"] = "trendingStock";
    LivePriceSymbolsKeyEnum["CATALOG"] = "catalog";
    LivePriceSymbolsKeyEnum["SECTOR"] = "sector";
    LivePriceSymbolsKeyEnum["WATCHLIST"] = "watchlist";
    LivePriceSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    LivePriceSymbolsKeyEnum["IHSG_WIDGET"] = "ihsgWidget";
    LivePriceSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    LivePriceSymbolsKeyEnum["TRANSACTION_FORM"] = "transactionForm";
    LivePriceSymbolsKeyEnum["TRADE_PAGE"] = "tradePage";
    LivePriceSymbolsKeyEnum["PORTFOLIO_DETAIL"] = "portfolioDetail";
    LivePriceSymbolsKeyEnum["ORDERLIST_DETAIL"] = "orderlistDetail";
    LivePriceSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(LivePriceSymbolsKeyEnum || (LivePriceSymbolsKeyEnum = {}));


/***/ }),

/***/ 35320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useLivePriceSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _liveprice_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66620);


var useLivePriceSender = function(key, symbols) {
    var setLivePriceSymbols = (0,_liveprice_store__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceStore */ .H)().setLivePriceSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var listSymbol = stringSymbols ? stringSymbols.split(",") : [];
        setLivePriceSymbols(key, listSymbol);
        return function() {
            return setLivePriceSymbols(key, []);
        };
    }, [
        key,
        stringSymbols,
        setLivePriceSymbols
    ]);
};


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 12 modules
var websocket_pb = __webpack_require__(24513);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx


















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        (ref = socket.current) === null || ref === void 0 ? void 0 : ref.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 49696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedMessageEffect = function(channel, key, action) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (action) {
            setAction(channel, key, action);
            return function() {
                return removeAction(channel, key);
            };
        }
    }, [
        channel,
        key,
        action
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedMessageEffect);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 14467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    activeModal: undefined,
    modalProps: {}
};
var useGlobalModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setActiveModal: function(activeModal, props) {
            set({
                activeModal: activeModal
            });
            if (activeModal) {
                get().setModalProps(activeModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                    onCancel: function() {
                        if (!(props === null || props === void 0 ? void 0 : props.preventClose)) get().setActiveModal();
                        if (props === null || props === void 0 ? void 0 : props.onCancel) props.onCancel();
                    }
                }));
            }
        },
        setModalProps: function(type, props) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(function(state) {
                state.modalProps[type] = props;
            }));
        },
        resetActiveModal: function() {
            return set({
                activeModal: undefined
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalModalStore);


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18364);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 24949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getOrderDetail; },
/* harmony export */   "k": function() { return /* binding */ bulkCancelByOrderId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4621);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96563);





var bulkCancelByOrderId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderIds) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.bulkCancelByOrderId */ .Li.bulkCancelByOrderId, {
                        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUiRef */ .TW)(),
                        order_id: orderIds
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bulkCancelByOrderId(orderIds) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.orderDetail */ .Li.orderDetail, {
                        params: {
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 87127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12902);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75413);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24949);








var initialState = {
    data: undefined,
    isLoading: false
};
var useOrderDetailStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetail: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
                var axiosResponse, _data, responseData, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_2__/* .getOrderDetail */ .d)(orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            data = utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__/* ["default"].orderDetail */ .Z.orderDetail(responseData);
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderDetail: function() {
            set(initialState);
        },
        updateOrderDetail: function(newData) {
            var ref;
            if (typeof newData !== "object") return;
            var currentOrderId = (ref = get().data) === null || ref === void 0 ? void 0 : ref.orderid;
            if (currentOrderId !== newData.orderid) return;
            set((0,immer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
                state.data = newData;
            }));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOrderDetailStore);


/***/ }),

/***/ 98976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_usePortfolioDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/portfolio.ts





var getPortfolio = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var targetAPI;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    targetAPI = (0,utils/* getTargetAPI */.Ai)();
                    return _ctx.abrupt("return", trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolio */.Db.portfolio[targetAPI]));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPortfolio() {
        return _ref.apply(this, arguments);
    };
}();
var getPortfolioDetail = function(symbol) {
    var targetAPI = (0,utils/* getTargetAPI */.Ai)();
    return trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolioDetail */.Db.portfolioDetail[targetAPI](symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts








var initialState = {
    data: {},
    dayTrade: {},
    isLoading: false
};
var usePortfolioDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setCurrentSymbol: function(symbol) {
            set({
                data: {
                    symbol: symbol
                }
            });
        },
        loadPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, _data, responseData, result, day_trade, data, dataDaytrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getPortfolioDetail(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            result = responseData.result, day_trade = responseData.day_trade;
                            data = transformData/* default.portfolioItem */.Z.portfolioItem(result);
                            dataDaytrade = transformData/* default.portfolioItem */.Z.portfolioItem(day_trade);
                            set({
                                data: data,
                                dayTrade: dataDaytrade,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetPortfolioDetail: function() {
            set(initialState);
        },
        updatePortfolioDetail: function(newData) {
            var checkSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref;
            if (typeof newData !== "object") return;
            var currentSymbol = (ref = get().data) === null || ref === void 0 ? void 0 : ref.symbol;
            if (currentSymbol !== newData.symbol && checkSymbol) return;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (isDayTrade) {
                    state.dayTrade = (0,_object_spread/* default */.Z)({}, state.dayTrade, newData);
                } else {
                    state.data = (0,_object_spread/* default */.Z)({}, state.data, newData);
                }
            }));
        }
    });
});
/* harmony default export */ var stores_usePortfolioDetailStore = (usePortfolioDetailStore);


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSecuritiesContext; },
/* harmony export */   "i": function() { return /* binding */ SecuritiesContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SecuritiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isAuthorized: false,
    token: undefined,
    socket: undefined,
    setChannel: function() {},
    setAction: function() {},
    removeAction: function() {}
});
var useSecuritiesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SecuritiesContext);
    if (context === undefined) {
        throw new Error("useSecuritiesContext must be used within a SecuritiesProvider");
    }
    return context;
};



/***/ }),

/***/ 93313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "Dp": function() { return /* binding */ UPTIME; },
/* harmony export */   "FJ": function() { return /* binding */ SecuritiesMessageCase; },
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "LU": function() { return /* binding */ MAX_POLLING_ATTEMPTS; },
/* harmony export */   "Nl": function() { return /* binding */ HEARTBEAT_FACTOR; },
/* harmony export */   "S0": function() { return /* binding */ DATA_ACTION; },
/* harmony export */   "aG": function() { return /* binding */ RECONNECT_INTERVAL; },
/* harmony export */   "al": function() { return /* binding */ HEARTBEAT_INTERVAL; },
/* harmony export */   "kQ": function() { return /* binding */ ReadyState; },
/* harmony export */   "pm": function() { return /* binding */ MAX_RECONNECT_ATTEMPTS; }
/* harmony export */ });
var RECONNECT_INTERVAL = 30000; // 30 seconds
var HEARTBEAT_INTERVAL = 15000; // 15 seconds
var HEARTBEAT_FACTOR = 1.5; // 1.5 times the heartbeat interval
var MAX_RECONNECT_ATTEMPTS = 3;
var MAX_POLLING_ATTEMPTS = 50;
var UPTIME = 2000; // 2 seconds
var SecuritiesMessageCase = {
    SUMMARY: "portfolioSummary",
    PORTFOLIO_LIST: "portfolioList",
    PORTFOLIO_DETAIL: "portfolioDetail",
    PORTFOLIO_DETAIL_DAY_TRADE: "portfolioDetailDayTrade",
    ORDER_LIST: "orderList",
    ORDER_DETAIL: "orderDetail"
};
var DATA_ACTION = {
    UPSERT: 1,
    DELETE: 2
};
var ERROR_CODE;
(function(ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ERROR_CODE[ERROR_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    ERROR_CODE[ERROR_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));
var ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState || (ReadyState = {}));
var NetworkStatus;
(function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "online";
    NetworkStatus["OFFLINE"] = "offline";
})(NetworkStatus || (NetworkStatus = {}));


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ SecuritiesChannel; },
/* harmony export */   "e7": function() { return /* binding */ PayloadCase; }
/* harmony export */ });
/* unused harmony exports RequestCommand, RequestChannel */
var SecuritiesChannel;
(function(SecuritiesChannel) {
    SecuritiesChannel["PING"] = "ping";
    SecuritiesChannel["AUTH"] = "auth";
    SecuritiesChannel["SECURITIES"] = "securities";
})(SecuritiesChannel || (SecuritiesChannel = {}));
var PayloadCase;
(function(PayloadCase) {
    PayloadCase["COMMAND"] = "command";
    PayloadCase["SUBSCRIBE"] = "subscribe";
    PayloadCase["UNSUBSCRIBE"] = "unsubscribe";
})(PayloadCase || (PayloadCase = {}));
var RequestCommand;
(function(RequestCommand) {
    RequestCommand[RequestCommand["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestCommand[RequestCommand["PING"] = 1] = "PING";
    RequestCommand[RequestCommand["AUTH"] = 2] = "AUTH";
})(RequestCommand || (RequestCommand = {}));
var RequestChannel;
(function(RequestChannel) {
    RequestChannel[RequestChannel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestChannel[RequestChannel["SECURITIES_LIVE_PORTO"] = 1] = "SECURITIES_LIVE_PORTO";
})(RequestChannel || (RequestChannel = {}));


/***/ }),

/***/ 77596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePortfolio; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.types.ts
var securities_store_types = __webpack_require__(17985);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioSender.ts





function usePortfolioSender(allowUnsubscribe) {
    var ref = (0,SecuritiesContext/* useSecuritiesContext */.S)(), setChannel = ref.setChannel, socket = ref.socket, token = ref.token, isAuthorized = ref.isAuthorized;
    var accountNumber = (0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return s.accountNumber;
    });
    var handleAction = (0,react.useCallback)(function(actionType) {
        var isSubscribe = actionType === securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE;
        var channelPayload = isSubscribe ? utils/* default.createSubscribePayload */.ZP.createSubscribePayload(accountNumber) : utils/* default.createUnsubscribePayload */.ZP.createUnsubscribePayload(accountNumber);
        if (socket && accountNumber) {
            setChannel(securities_store_types/* SecuritiesChannel.SECURITIES */.Jd.SECURITIES, channelPayload);
        }
    }, [
        setChannel,
        socket,
        token,
        accountNumber
    ]);
    (0,react.useEffect)(function() {
        if (isAuthorized) {
            handleAction(securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE);
        }
        return function() {
            if (allowUnsubscribe) handleAction(securities_store_types/* PayloadCase.UNSUBSCRIBE */.e7.UNSUBSCRIBE);
        };
    }, [
        isAuthorized,
        handleAction
    ]);
};

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/utils/securities/formatter.ts
var formatter = __webpack_require__(89237);
// EXTERNAL MODULE: ./src/global/Securities/types/store/order.ts
var store_order = __webpack_require__(91037);
;// CONCATENATED MODULE: ./src/utils/securities/transformWebsocketData.ts


var convertSideToAction = function(side) {
    return side === store_order/* iOrderSide.BUY */.vT.BUY ? store_order/* OrderAction.Buy */.iX.Buy : store_order/* OrderAction.Sell */.iX.Sell;
};
var portfolioSummary = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, trading = ref.trading, amount = ref.amount, profitLoss = ref.profitLoss, gain = ref.gain, equity = ref.equity, debt = ref.debt;
    return {
        tradingbalance: trading === null || trading === void 0 ? void 0 : trading.balance,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_allocated: amount === null || amount === void 0 ? void 0 : amount.allocated,
        amount_creditlimit: amount === null || amount === void 0 ? void 0 : amount.creditLimit,
        unrealised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.unrealised,
        realised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.realised,
        profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.net,
        gain: gain,
        equity: equity,
        debt_ratio: debt === null || debt === void 0 ? void 0 : debt.ratio,
        debt_total: debt === null || debt === void 0 ? void 0 : debt.total,
        debt_market_value: debt === null || debt === void 0 ? void 0 : debt.marketValue
    };
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, isSharia = ref.isSharia;
    return {
        allow_order: (0,formatter/* convertBooleanToNumber */.y0)(flags === null || flags === void 0 ? void 0 : flags.allowOrder),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,formatter/* getExercisedData */.a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.haveSmartOrder,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stockOnHand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.marketValue,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profitLoss,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.canBuy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.canSell,
        is_sharia: isSharia
    };
};
var portfolioList = function(portfolio) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref10.summary, smartOrderInfo = ref10.smartOrderInfo, results = ref10.results, dayTrade = ref10.dayTrade;
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : (ref = summary.trading) === null || ref === void 0 ? void 0 : ref.balance,
        amount_invested: summary === null || summary === void 0 ? void 0 : (ref1 = summary.amount) === null || ref1 === void 0 ? void 0 : ref1.invested,
        amount_allocated: summary === null || summary === void 0 ? void 0 : (ref2 = summary.amount) === null || ref2 === void 0 ? void 0 : ref2.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : (ref3 = summary.amount) === null || ref3 === void 0 ? void 0 : ref3.creditLimit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : (ref4 = summary.profitLoss) === null || ref4 === void 0 ? void 0 : ref4.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : (ref5 = summary.profitLoss) === null || ref5 === void 0 ? void 0 : ref5.realised,
        profitloss: summary === null || summary === void 0 ? void 0 : (ref6 = summary.profitLoss) === null || ref6 === void 0 ? void 0 : ref6.net,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        show_create_smartorder: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.canCreate,
        auto_order_info: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.info,
        result: results === null || results === void 0 ? void 0 : results.map(function(result) {
            return portfolioItem(result);
        }),
        day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.map(function(result) {
            return portfolioItem(result);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : (ref7 = summary.debt) === null || ref7 === void 0 ? void 0 : ref7.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : (ref8 = summary.debt) === null || ref8 === void 0 ? void 0 : ref8.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : (ref9 = summary.debt) === null || ref9 === void 0 ? void 0 : ref9.marketValue
    };
};
var orderDetail = function(order) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = order !== null && order !== void 0 ? order : {}, action = ref13.action, amount = ref13.amount, dayTrade = ref13.dayTrade, gtc = ref13.gtc, marketOrderId = ref13.marketOrderId, message = ref13.message, orderId = ref13.orderId, price = ref13.price, qty = ref13.qty, side = ref13.side, smartOrder = ref13.smartOrder, statusText = ref13.statusText, symbol = ref13.symbol, time = ref13.time, isSharia = ref13.isSharia, securitiesKind = ref13.securitiesKind;
    var securities_kind = (0,formatter/* convertSecuritiesKind */.KH)(securitiesKind);
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var platforms = {
        0: store_order/* PlatformOrderTypes.UNSPECIFIED */.F4.UNSPECIFIED,
        1: store_order/* PlatformOrderTypes.LIMIT */.F4.LIMIT,
        2: store_order/* PlatformOrderTypes.FAK */.F4.FAK
    };
    return {
        action: convertSideToAction(side),
        amend_action: action.canAmend,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matchedTotal,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action.canCancel,
        config_type: (0,formatter/* convertSmartOrderConfigType */.Hc)(smartOrder === null || smartOrder === void 0 ? void 0 : (ref1 = smartOrder.configType) === null || ref1 === void 0 ? void 0 : ref1.toString()),
        gtc: (0,formatter/* convertBooleanToNumber */.y0)(gtc === null || gtc === void 0 ? void 0 : gtc.isGtc),
        label: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.label,
        market_orderid: marketOrderId,
        message: message,
        order_done: qty === null || qty === void 0 ? void 0 : qty.lotDone,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lotOpen,
        order_total: qty === null || qty === void 0 ? void 0 : qty.lotTotal,
        orderid: orderId,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.orderId,
        status: statusText,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,formatter/* getHourFromTimestamp */.aF)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        time_match: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.match)),
        time_open: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        trigger_price: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.triggerPrice,
        day_trade_is_day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.isDayTrade,
        day_trade_force_sell_event: (0,formatter/* convertForceSellEvent */.zn)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.forceSellEvent),
        day_trade_message: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.message,
        is_sharia: isSharia,
        trailing_stop: (smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.trailingStop) ? {
            id: (smartOrder === null || smartOrder === void 0 ? void 0 : (ref2 = smartOrder.trailingStop) === null || ref2 === void 0 ? void 0 : ref2.id.toString()) || "",
            price_algorithm: {
                type: smartOrder === null || smartOrder === void 0 ? void 0 : (ref3 = smartOrder.trailingStop) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.priceAlgorithm) === null || ref4 === void 0 ? void 0 : ref4.type,
                value: smartOrder === null || smartOrder === void 0 ? void 0 : (ref5 = smartOrder.trailingStop) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.priceAlgorithm) === null || ref6 === void 0 ? void 0 : ref6.value
            },
            stop_price: {
                currency_code: smartOrder === null || smartOrder === void 0 ? void 0 : (ref7 = smartOrder.trailingStop) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.stopPrice) === null || ref8 === void 0 ? void 0 : ref8.currencyCode,
                units: smartOrder === null || smartOrder === void 0 ? void 0 : (ref9 = smartOrder.trailingStop) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.stopPrice) === null || ref10 === void 0 ? void 0 : ref10.units.toString(),
                nanos: smartOrder === null || smartOrder === void 0 ? void 0 : (ref11 = smartOrder.trailingStop) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.stopPrice) === null || ref12 === void 0 ? void 0 : ref12.nanos
            }
        } : null,
        platform_order_type: platforms[order.platformOrderType]
    };
};
var orderList = function(response) {
    var orders = (response !== null && response !== void 0 ? response : {}).orders;
    return orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
};
/* harmony default export */ var transformWebsocketData = ({
    portfolioSummary: portfolioSummary,
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList
});

;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useSecuritiesMessage.ts


var useSecuritiesMessage = function(channel, action) {
    var ref = (0,react.useContext)(SecuritiesContext/* SecuritiesContext */.i), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react.useEffect)(function() {
        if (action) {
            setAction(channel, action);
            return function() {
                removeAction(channel);
            };
        }
        return undefined;
    }, [
        channel,
        action,
        setAction,
        removeAction
    ]);
};
/* harmony default export */ var hooks_useSecuritiesMessage = (useSecuritiesMessage);

// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioReceiver.ts








function usePortfolioReceiver() {
    var ref = (0,tradingData/* default */.Z)(function(s) {
        return {
            updatePortfolioSummary: s.updatePortfolioSummary,
            updatePortfolioList: s.updatePortfolioList,
            updatePortfolioItem: s.updatePortfolioItem,
            deletePortfolioListItem: s.deletePortfolioItem,
            updateOrderList: s.updateOrderList,
            updateOrderListItem: s.updateOrderListItem,
            deleteOrderListItem: s.deleteOrderListItem
        };
    }, shallow/* default */.Z), updatePortfolioSummary = ref.updatePortfolioSummary, updatePortfolioList = ref.updatePortfolioList, updatePortfolioItem = ref.updatePortfolioItem, deletePortfolioListItem = ref.deletePortfolioListItem, updateOrderList = ref.updateOrderList, updateOrderListItem = ref.updateOrderListItem, deleteOrderListItem = ref.deleteOrderListItem;
    var updatePortfolioDetail = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            updatePortfolioDetail: s.updatePortfolioDetail
        };
    }, shallow/* default */.Z).updatePortfolioDetail;
    var updateOrderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return {
            updateOrderDetail: s.updateOrderDetail
        };
    }, shallow/* default */.Z).updateOrderDetail;
    var handleReceiveMessage = (0,react.useCallback)(function(param) {
        var messageAction = param.action, message = param.message;
        if (!message) return;
        switch(message.case){
            case constants/* SecuritiesMessageCase.SUMMARY */.FJ.SUMMARY:
                {
                    var transformedData = transformWebsocketData.portfolioSummary(message.value);
                    updatePortfolioSummary(transformedData);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_LIST */.FJ.PORTFOLIO_LIST:
                {
                    var transformedData1 = transformWebsocketData.portfolioList(message.value);
                    updatePortfolioList(transformedData1);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL */.FJ.PORTFOLIO_DETAIL:
                {
                    var transformedData2 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData2.symbol);
                        break;
                    }
                    updatePortfolioDetail(transformedData2);
                    updatePortfolioItem(transformedData2.symbol, transformedData2);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL_DAY_TRADE */.FJ.PORTFOLIO_DETAIL_DAY_TRADE:
                {
                    var transformedData3 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData3.symbol, true);
                        break;
                    }
                    updatePortfolioDetail(transformedData3, true, true);
                    updatePortfolioItem(transformedData3.symbol, transformedData3, true);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_LIST */.FJ.ORDER_LIST:
                {
                    var transformedData4 = transformWebsocketData.orderList(message.value);
                    updateOrderList(transformedData4);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_DETAIL */.FJ.ORDER_DETAIL:
                {
                    var transformedData5 = transformWebsocketData.orderDetail(message.value);
                    updateOrderListItem(transformedData5.orderid, transformedData5);
                    updateOrderDetail(transformedData5);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deleteOrderListItem(transformedData5.orderid);
                    }
                    break;
                }
            default:
                break;
        }
    }, []);
    hooks_useSecuritiesMessage("securities", handleReceiveMessage);
};

;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts


var useGenPortfolio = function() {
    var allowUnsubscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    usePortfolioSender(allowUnsubscribe);
    usePortfolioReceiver();
};
/* harmony default export */ var usePortfolio = (useGenPortfolio);


/***/ }),

/***/ 46238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c$": function() { return /* binding */ createPingPayload; },
/* harmony export */   "y_": function() { return /* binding */ generateWSCookie; }
/* harmony export */ });
/* unused harmony exports getAccountNumber, createUint8Array, createSubscribePayload, createUnsubscribePayload */
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11763);
/* harmony import */ var _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17985);


var getAccountNumber = function() {
    var accountNumber = securitiesLocalStorage.getSecuritiesAccountInfo().accountNumber;
    return accountNumber !== null && accountNumber !== void 0 ? accountNumber : null;
};
var createUint8Array = function(value) {
    var textEncoder = new TextEncoder();
    return textEncoder.encode(value);
};
var createPingPayload = function() {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.COMMAND */ .e7.COMMAND,
            value: 1
        },
        value: new Uint8Array()
    };
};
var createSubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.SUBSCRIBE */ .e7.SUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var createUnsubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.UNSUBSCRIBE */ .e7.UNSUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var generateWSCookie = function(value) {
    return "gen-websocket=".concat(value, "; domain=stockbit.com; path=/v1; Secure;");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createPingPayload: createPingPayload,
    createSubscribePayload: createSubscribePayload,
    createUnsubscribePayload: createUnsubscribePayload,
    generateWSCookie: generateWSCookie
});


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 1349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78372);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);








var marketDetectorURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/marketdetectors");
var findataViewURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/marketdetectors");
var seasonalityURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/seasonality");
var emittenURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten");
var hotlistURL = "".concat(emittenURL, "/hotlist");
var companyPriceFeedURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed");
var emittenMetadataURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten-metadata");
var orderTradeURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/order-trade");
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"].noAlert */ .Z.noAlert;
// trending
var getTrendingCompany = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/trending"));
};
var getIHSG = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/IHSG/info"));
};
var getTendingCompanyPrices = function(param) {
    var symbol = param.symbol, _interval = param.interval, interval = _interval === void 0 ? "5" : _interval;
    if (typeof symbol === "string") {
        return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
            params: {
                interval: interval,
                symbol: symbol
            }
        });
    }
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/company-price-feed/prices/close"), {
        params: {
            interval: interval,
            symbol: symbol
        },
        paramsSerializer: function(params) {
            return qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params);
        }
    });
};
// Hotlist
var getTopGainer = function() {
    return requestExodus.get("".concat(hotlistURL, "/topgainer?limit=10"));
};
var getTopLoser = function() {
    return requestExodus.get("".concat(hotlistURL, "/toploser?limit=10"));
};
var getMostActive = function() {
    return requestExodus.get("".concat(hotlistURL, "/mostactive?limit=10"));
};
/**
 * Search company with keyword
 */ var getSearchCompany = function(params) {
    return requestExodus.get("/watchlist/search/company", {
        params: params
    });
};
var getCompanyInfo = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyProfile = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/profile"));
};
var getCompanyChart = function(symbol, timeframe) {
    var includePrevious = timeframe === "ytd" || timeframe === "1w";
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol, "/daily"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            timeframe: timeframe
        }, includePrevious && {
            is_include_previous_historical: true
        })
    });
};
var getMarketDetector = function(symbol, params) {
    return requestExodus.get("".concat(marketDetectorURL, "/").concat(symbol), {
        params: params
    });
};
var getTopBroker = function(params) {
    return requestExodus.get("order-trade/broker/top", {
        params: params
    });
};
var getBrokerList = function(params) {
    return requestExodus.get("".concat(findataViewURL, "/brokers"), {
        params: params
    });
};
var getMarketDetectorActivity = function(brokerCode, params) {
    return requestExodus.get("".concat(findataViewURL, "/activity/").concat(brokerCode, "/detail"), {
        params: params
    });
};
var getAllCorpAction = function(symbol) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(symbol), {
        params: {
            limit: limit
        }
    });
};
var getCompanyCorpAction = function(symbol, category) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(category), {
        params: {
            symbol: symbol
        }
    });
};
/**
 * Get company major holder, related to get company insider
 * @param {Object} props
 * @param {string=} props.insider
 * @param {string} props.symbol
 * @param {string=} props.datestart
 * @param {string=} props.dateend
 * @param {number=} props.page
 * @returns {APIResponse}
 */ var getCompanyMajorholder = function(param) {
    var _insider = param.insider, insider = _insider === void 0 ? "" : _insider, symbol = param.symbol, _datestart = param.datestart, datestart = _datestart === void 0 ? "" : _datestart, _dateend = param.dateend, dateend = _dateend === void 0 ? "" : _dateend, page = param.page;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/insider/company/majorholder"), {
        params: {
            insider: insider,
            symbol: symbol,
            date_start: datestart,
            date_end: dateend,
            page: page
        }
    });
};
/**
 * Get company seasonality data
 * @param {string} symbol
 * @param {string|number} year
 * @param {string|number} backyear
 * @return {APIResponse}
 */ var getCompanySeasonality = function(symbol, year, backyear) {
    return requestExodus.get("".concat(seasonalityURL, "/").concat(symbol), {
        params: {
            year: year,
            back_year: backyear
        }
    });
};
var getCompanyKeystat = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/keystats/ratio/v1/").concat(symbol), {
        params: {
            year_limit: 10
        }
    });
};
/**
 * Get financial reports
 * @param {Object} params
 * @param {string} params.symbol
 * @param {string} params.datatype
 * @param {string} params.reporttype
 * @param {string} params.statement
 * @return {APIResponse}
 */ var getFinancialReport = function(param) {
    var symbol = param.symbol, _datatype = param.datatype, datatype = _datatype === void 0 ? 1 : _datatype, reporttype = param.reporttype, statement = param.statement;
    var url = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/findata-view/company/financial");
    return requestExodus.get(url, {
        params: {
            symbol: symbol,
            data_type: datatype,
            report_type: reporttype,
            statement_type: statement
        }
    }).then(function(res) {
        var newRes = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, res.data);
        newRes.data.defaultCurrency = newRes.data.default_currency;
        newRes.data.htmlReport = newRes.data.html_report;
        newRes.data.rounding_value = {
            idr: newRes.data.rounding_value[0],
            usd: newRes.data.rounding_value[1]
        };
        delete newRes.data.default_currency;
        delete newRes.data.html_report;
        return newRes;
    });
};
/**
 * Get Analyst Rating
 * @param {string} symbol
 * @return {APIResponse}
 */ var getAnalystRating = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol));
};
var getAnalystConsensus = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol, "/consensus"));
};
var getCompanyHoldingCompositionToken = function() {
    return requestExodus.post("".concat(emittenMetadataURL, "/shareholders/token"));
};
var getCompanyHoldingComposition = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, type, timeframe, token, isFromWebview, _tries, tries, getToken, Authorization, res, ref, ref1, statusCode, newToken;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol, type = param.type, timeframe = param.timeframe, token = param.token, isFromWebview = param.isFromWebview, _tries = param.tries, tries = _tries === void 0 ? 0 : _tries;
                    getToken = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var ref, tokenResponse, data;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return getCompanyHoldingCompositionToken();
                                    case 3:
                                        tokenResponse = _ctx.sent;
                                        data = tokenResponse.data;
                                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.value);
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function getToken() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t1 = token;
                    if (_ctx.t1) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t2 = !isFromWebview;
                    if (!_ctx.t2) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 8;
                    return getToken();
                case 8:
                    _ctx.t2 = _ctx.sent;
                case 9:
                    _ctx.t1 = _ctx.t2;
                case 10:
                    _ctx.t0 = _ctx.t1;
                    if (_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t0 = "";
                case 13:
                    Authorization = _ctx.t0;
                    _ctx.prev = 14;
                    if (Authorization) {
                        _ctx.next = 17;
                        break;
                    }
                    throw Error("No Access Token found");
                case 17:
                    _ctx.next = 19;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(emittenMetadataURL, "/shareholders/").concat(symbol, "/chart"), {
                        params: {
                            symbol: symbol,
                            value_year: timeframe,
                            shareholder_type: type
                        },
                        headers: {
                            Authorization: Authorization
                        }
                    });
                case 19:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 23:
                    _ctx.prev = 23;
                    _ctx.t3 = _ctx["catch"](14);
                    ;
                    ;
                    statusCode = (ref1 = _ctx.t3 === null || _ctx.t3 === void 0 ? void 0 : (ref = _ctx.t3.cause) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : 401;
                    if (!(isFromWebview || statusCode !== 401 || tries >= 2)) {
                        _ctx.next = 30;
                        break;
                    }
                    throw _ctx.t3;
                case 30:
                    _ctx.next = 32;
                    return getToken();
                case 32:
                    newToken = _ctx.sent;
                    return _ctx.abrupt("return", getCompanyHoldingComposition({
                        symbol: symbol,
                        type: type,
                        timeframe: timeframe,
                        isFromWebview: isFromWebview,
                        token: newToken,
                        tries: tries + 1
                    }));
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                23
            ]
        ]);
    }));
    return function getCompanyHoldingComposition(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get company contact
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyContact = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/contact"));
};
var getTradeBook = function(params) {
    return requestExodus.get("".concat(orderTradeURL, "/trade-book"), {
        params: params
    });
};
var getInitRunningTrade = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/running-trade"), {
        params: params
    });
};
var getInitRunningTradeV2 = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/v2/running-trade"), {
        params: params
    });
};
var getCompanySubsidiary = function(symbol) {
    return requestExodus.get("".concat(emittenMetadataURL, "/subsidiary/").concat(symbol));
};
var getCompanyInfoV2 = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getCompanyChartV2 = function(symbol, timeframe) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getCompanyFinItem = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
var getGuestCompanyV2 = function(symbol, exchange) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getGuestCompanyChartV2 = function(symbol, timeframe) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getGuestCompanyFinItem = function(symbol, exchange) {
    return axios__WEBPACK_IMPORTED_MODULE_5___default().get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_4__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTrendingCompany: getTrendingCompany,
    getIHSG: getIHSG,
    getTendingCompanyPrices: getTendingCompanyPrices,
    getSearchCompany: getSearchCompany,
    getCompanyProfile: getCompanyProfile,
    getCompanyInfo: getCompanyInfo,
    getCompanyChart: getCompanyChart,
    getAnalystRating: getAnalystRating,
    getAnalystConsensus: getAnalystConsensus,
    getCompanyContact: getCompanyContact,
    getCompanyInfoV2: getCompanyInfoV2,
    getCompanyChartV2: getCompanyChartV2,
    getCompanyFinItem: getCompanyFinItem,
    // Hotlist
    getTopGainer: getTopGainer,
    getTopLoser: getTopLoser,
    getMostActive: getMostActive,
    // bandar detector
    getMarketDetector: getMarketDetector,
    getBrokerList: getBrokerList,
    getMarketDetectorActivity: getMarketDetectorActivity,
    getTopBroker: getTopBroker,
    // related to profile APIs
    getCompanyCorpAction: getCompanyCorpAction,
    getCompanyMajorholder: getCompanyMajorholder,
    getCompanySeasonality: getCompanySeasonality,
    getCompanyKeystat: getCompanyKeystat,
    getFinancialReport: getFinancialReport,
    getAllCorpAction: getAllCorpAction,
    // used for trading modal
    getCompanyHoldingCompositionToken: getCompanyHoldingCompositionToken,
    getCompanyHoldingComposition: getCompanyHoldingComposition,
    // Company Price Feed,
    getTradeBook: getTradeBook,
    getInitRunningTrade: getInitRunningTrade,
    getCompanySubsidiary: getCompanySubsidiary,
    getInitRunningTradeV2: getInitRunningTradeV2,
    getGuestCompanyV2: getGuestCompanyV2,
    getGuestCompanyChartV2: getGuestCompanyChartV2,
    getGuestCompanyFinItem: getGuestCompanyFinItem
});


/***/ }),

/***/ 60374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shallow; }
/* harmony export */ });
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}




/***/ })

}]);